// @flow

import React from 'react';

export default () => <div>Company Settings</div>;
